import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { toast } from "react-toastify";

const Epf = ({ openModal, setOpenModal, appId }) => {
  console.log("appId::: ", appId);
  const [inputNumber, setInputNumber] = useState(appId);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEPFValidation = async () => {
      try {
        const response = await axios.get(
          `https://tap.salarytap.in:8083/salarytap/validepf/${appId}`
        );
        if (response.data.resultCode == 101) {
          setResult(response.data);
        } else if (response.data.resultCode == null) {
          handleSubmit();
        } else {
          setResult(null);
        }
      } catch (error) {
        console.error("Failed to fetch EPF validation data:", error);
      }
    };

    if (appId) {
      fetchEPFValidation();
    }
  }, []);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `https://tap.salarytap.in:8083/salarytap/validatepf/${appId}`
      );

      if (response.data == "successfull") {
        axios
          .get(`https://tap.salarytap.in:8083/salarytap/validepf/${appId}`)
          .then((res) => {
            setResult(res.data);
          });
      } else {
        toast.warning("App id is not valid");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to validate EPF number");
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  // Parse the nested JSON response
  const parseResponse = () => {
    if (!result?.response) return null;
    try {
      return JSON.parse(result.response);
    } catch (e) {
      console.error("Error parsing response:", e);
      return null;
    }
  };

  const parsedResponse = parseResponse();

  return (
    <div
      className={`modal fade ${openModal ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{ backgroundColor: openModal ? "rgba(0,0,0,0.5)" : "transparent" }}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">EPF Validator</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() => {
                setOpenModal(false);
                setResult(null);
                setInputNumber("");
              }}
            ></button>
          </div>
          <div className="modal-body">
            {/* <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="col-md-8">
                  <div className="">
                    <label htmlFor="epfNumber" className="form-label">
                      Enter App Client Id
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="epfNumber"
                      value={inputNumber}
                      onChange={(e) => setInputNumber(e.target.value)}
                      placeholder="Enter App Client Id"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 d-flex align-items-end">
                  <div className="d-grid w-100">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Validating...
                        </>
                      ) : (
                        "Validate"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form> */}

            {error && <div className="alert alert-danger">{error}</div>}

            {result && (
              <div className="mt-3">
                <h4 className="mb-3">EPF Validation Details</h4>

                <div className="card mb-3">
                  <div className="card-header bg-light">
                    <h5 className="mb-0">Basic Information</h5>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th className="w-25">Name</th>
                            <td>{result.name}</td>
                          </tr>
                          <tr>
                            <th>Establishment Name</th>
                            <td>{result.establishmentName}</td>
                          </tr>
                          <tr>
                            <th>Date of Joining</th>
                            <td>{result.dateOfJoining}</td>
                          </tr>
                          <tr>
                            <th>Date of Exit</th>
                            <td>{result.dateOfExit || "Currently Employed"}</td>
                          </tr>
                          <tr>
                            <th>Gender</th>
                            <td>{result.gender}</td>
                          </tr>
                          <tr>
                            <th>Date of Birth</th>
                            <td>{result.dateOfBirth}</td>
                          </tr>
                          <tr>
                            <th>Mobile</th>
                            <td>{result.mobile}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {parsedResponse && (
                  <>
                    <div className="card mb-3">
                      <div className="card-header bg-light">
                        <h5 className="mb-0">EPF Summary</h5>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <tbody>
                              <tr>
                                <th className="w-25">UAN Number</th>
                                <td>
                                  {parsedResponse.result?.summary?.matching_uan}
                                </td>
                              </tr>
                              <tr>
                                <th>Member ID</th>
                                <td>
                                  {
                                    parsedResponse.result?.summary
                                      ?.recent_employer_data?.member_id
                                  }
                                </td>
                              </tr>
                              <tr>
                                <th>Establishment ID</th>
                                <td>
                                  {
                                    parsedResponse.result?.summary
                                      ?.recent_employer_data?.establishment_id
                                  }
                                </td>
                              </tr>
                              <tr>
                                <th>Employment Status</th>
                                <td>
                                  {result.isEmployed === "true"
                                    ? "Currently Employed"
                                    : "Not Employed"}
                                </td>
                              </tr>
                              <tr>
                                <th>Total Employees</th>
                                <td>{result.employeesCount}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="card mb-3">
                      <div className="card-header bg-light">
                        <h5 className="mb-0">Recent PF Filings</h5>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-bordered table-striped">
                            <thead className="table-dark">
                              <tr>
                                <th>Month</th>
                                <th>Filing Status</th>
                                <th>Total Amount (₹)</th>
                                <th>Employees Count</th>
                              </tr>
                            </thead>
                            <tbody>
                              {parsedResponse.result?.epfo_details?.pf_filing_details?.map(
                                (filing, index) => (
                                  <tr key={index}>
                                    <td>{filing.wage_month}</td>
                                    <td>
                                      <span className="badge bg-success">
                                        Filed
                                      </span>
                                    </td>
                                    <td>
                                      {filing.total_amount.toLocaleString()}
                                    </td>
                                    <td>{filing.employees_count}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
            {!result && (
              <div className="mt-5 d-flex">
                {" "}
                <h1>No Data Found</h1>{" "}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setOpenModal(false);
                setResult(null);
                setInputNumber("");
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Epf;
